"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFrame = exports.applyScaleStyling = exports.ListenerCounter = exports.getIframeUrl = void 0;
/**
 * Get the URL to the Studio Player for the given environment.
 *
 */
exports.getIframeUrl = function (environment, playerUrl) {
    if (typeof playerUrl === "string") {
        return playerUrl;
    }
    switch (environment) {
        case "production":
            return "https://studio-player.screencloud.com";
        case "staging":
            return "https://staging.studio-player.screencloud.com";
        case "edge":
            return "https://edge.studio-player.screencloud.com";
        case "development":
            return "http://localhost:3000";
    }
};
/**
 * Set up listenerCounter class to add and remove event listeners
 */
var ListenerCounter = /** @class */ (function () {
    function ListenerCounter() {
        this.listenersMap = new Map();
    }
    ListenerCounter.prototype.add = function (type, listener) {
        var list = this.listenersMap.get(type) || [];
        this.listenersMap.set(type, list.concat(listener));
    };
    ListenerCounter.prototype.remove = function (type, listener) {
        var list = this.listenersMap.get(type) || [];
        if (list.length) {
            this.listenersMap.set(type, list.filter(function (l) { return l !== listener; }));
        }
    };
    ListenerCounter.prototype.removeAll = function (type) {
        this.listenersMap.delete(type);
    };
    ListenerCounter.prototype.get = function (type) {
        return this.listenersMap.get(type) || [];
    };
    ListenerCounter.prototype.getAll = function () {
        return Array.from(this.listenersMap);
    };
    ListenerCounter.prototype.clear = function () {
        this.listenersMap.clear();
    };
    return ListenerCounter;
}());
exports.ListenerCounter = ListenerCounter;
exports.applyScaleStyling = function (frame, simulatedDimensions, targetWidth, targetHeight) {
    if (frame && simulatedDimensions) {
        frame.style.width = simulatedDimensions.width + "px";
        frame.style.height = simulatedDimensions.height + "px";
        frame.style.transformOrigin = "0 0";
        // landscape mode
        if (simulatedDimensions.width >= simulatedDimensions.height) {
            frame.style.transform = "scale(" + (targetWidth || 0) / simulatedDimensions.width + ")";
        }
        // portrait mode
        else if (simulatedDimensions.height > simulatedDimensions.width) {
            frame.style.transform = "scale(" + (targetHeight || 0) / simulatedDimensions.height + ")";
        }
    }
};
exports.createFrame = function (environment, playerUrl, simulatedDimensions, targetWidth, targetHeight) {
    // create default iframe
    var frame = document.createElement("iframe");
    frame.setAttribute("src", exports.getIframeUrl(environment, playerUrl));
    frame.setAttribute("allow", "autoplay; fullscreen;");
    frame.style.border = "none";
    if (!simulatedDimensions) {
        frame.style.width = "100%";
        frame.style.height = "100%";
    }
    else {
        exports.applyScaleStyling(frame, simulatedDimensions, targetWidth, targetHeight);
    }
    return frame;
};
